import { isEmptyValue } from "./utils";

export const SEARCH_RESERVATION_URL = "search-reservation";
export const GET_RESERVATION_URL = "get-reservation";
export const GET_EXTRAS_URL = "get-extras";
export const GET_DOCUMENT_FILE_URL = "get-file-reservation";
export const GET_POST_VALIDATE_MAIL_URL = "post-validate-mail";
export const GET_QUOTATION_URL = "get-quotation";
export const POST_REQUEST_SIGNATURE_URL = "get-signature";
export const POST_CREATE_AGREEMENT = "post-agreement";
export const GET_AGREEMENT_FILE = "get-agreement-file";
export const POST_AGREEMENT_EMAIL = "send-agrement-email";
export const POST_PAYMENT = "post-payment";
export const POST_CHECKIN = "post-checkin";
export const GET_UPGRADE_URL = "get-upgrade";
export const KIOSK_CONFIG_URL = import.meta.env.KIOSK_CONFIG_API_URL;


export const ADDRESS_TYPES = [
    { id: 1, name: "Casa" },
    { id: 2, name: "Negocio" },
    { id: 3, name: "Principal" },
]

export const COUNTRIES_TYPES = COUNTRIES;
export const REGIMEN_FISCAL_TYPES = REGIMESFISCALES;
export const OFFICE_CODE = isEmptyValue(OFFICE) ? null: OFFICE.officeCode;
export const OFFICE_CURRENCYID = isEmptyValue(OFFICE) ? null: OFFICE.currencyId;
export const ADDTIONAL_DRIVER_CODE = "AD";
export const OFFICES_LIST = OFFICES;
export const SEARCH_RESERVATION_ERROR_VALUES = {
    1001: 'Search.missing_documents_customer',
    1002: 'Search.missing_ct',
    1003: 'Search.unregistered_customer',
    1004: 'Search.missing_address',
    1005: 'Search.pickup_passed',
}

export const EXTRA_TYPES = {
    daily: 'Daily',
    one_time: 'One time',

}

export const KIOSK_KEYBOARD_SELECTOR = 'input:not([readOnly]):not([type="date"])';
